module.exports = __webpack_public_path__ + "static/media/ukgov.34a3f784.png";